import endCurrentSession from './endCurrentSession';

export default endCurrentSession;
